<div class="section flex-percent flex-wrapper main-content">
    <div class="container container-33">
        <div class="full-width muckpile-map">
            <div #map class="full-height full-width"></div>
        </div>

        <div class="table-container mt-20">
            <mat-card class="full-width container">
                <div *ngIf="!(muckpileData$ | async)" class="container centered-content full-width half-height">
                    <mat-spinner *ngIf="(muckpileData$ | async) === undefined" strokeWidth="3" [diameter]="50"></mat-spinner>
                    <div *ngIf="(muckpileData$ | async) === null" class="container centered-content">
                        <mat-icon svgIcon="empty-data" class="not-found-svg"></mat-icon>
                        <div>No Data Found</div>
                    </div>
                </div>

                <muckpile-statistics 
                    [details]="(muckpileData$ | async)?.details"
                    [areaUnit]="areaUnit$ | async"
                    [particleSizeUnit]="particleSizeUnit$ | async">
                </muckpile-statistics>
            </mat-card>
        </div>
    </div>

    <div class="container container-67 flex-column">
        <mat-card>
            <mat-tab-group>
                <mat-tab label="Muckpile Details">
                    <ng-container class="chart-containers">
                        <div class="centered-content chart-header">
                            <button mat-flat-button
                                *ngIf="isCustomSizeEnabled(device$ | async) && ((muckpileData$ | async)?.imported_fragmentation) && (muckpileData$ | async)?.imported_fragmentation?.psd?.length !== 0"
                                class="off-sepc" [ngClass]="isImportedOffSpec ? 'off-spec-true' : 'off-spec-false'">
                                {{ isImportedOffSpec ? 'On' : 'Off'}} Spec</button>
                            <caption class="mt-1 text-underline font-bold chart-title imported-title">Imported Muckpile Fragmentation</caption>
                        </div>
                        <div class="charts-content cards">
                            <div *ngIf="!(muckpileData$ | async)" class="container centered-content">
                                <mat-spinner *ngIf="(muckpileData$ | async) === undefined" strokeWidth="3" [diameter]="50"></mat-spinner>
                                <div *ngIf="(muckpileData$ | async) === null" class="container centered-content">
                                    <mat-icon svgIcon="empty-data" class="not-found-svg"></mat-icon>
                                    <div>No Data Found</div>
                                </div>
                            </div>

                            <div *ngIf="(muckpileData$ | async)?.imported_fragmentation as importedFragment">
                                <div *ngIf="importedFragment && ((graph$ | async) === 'imported' || (graph$ | async) === 'comparison for both')">
                                <psd-chart [index]="0" [muckpileData]="importedFragment" [type]="'muckpile'" (offSpecEmitter)="setImportedOffSpec($event)"></psd-chart>
                            </div>
                            </div>

                            <div *ngIf="(muckpileData$ | async)?.imported_fragmentation?.psd?.length === 0 && ((graph$ | async) === 'imported' || (graph$ | async) === 'comparison for both')" class="container centered-content">
                                <mat-icon svgIcon="empty-data" class="not-found-svg"></mat-icon>
                                <div>No Data Imported</div>
                            </div>

                            <div *ngIf="(muckpileData$ | async)?.actual_fragmentation as actualFragment">
                                <div *ngIf="isEmptyObject(actualFragment) && ((graph$ | async) === 'tagged' || (graph$ | async) === 'comparison for both')" class="container centered-content">
                                    <mat-icon svgIcon="empty-data" class="not-found-svg"></mat-icon>
                                    <div>No Intervals/Dumps Tagged</div>
                                </div>
                                <div *ngIf="!isEmptyObject(actualFragment) && ((graph$ | async) === 'tagged' || (graph$ | async) === 'comparison for both')">
                                    <div class="centered-content chart-header">
                                        <button mat-flat-button *ngIf="isCustomSizeEnabled(device$ | async)" class="off-sepc"
                                            [ngClass]="isActualOffSpec ? 'off-spec-true' : 'off-spec-false'">{{ isActualOffSpec ? 'On' : 'Off'}} Spec
                                        </button>
                                        <caption class="mt-1 text-underline font-bold chart-title">Tagged Data Fragmentation</caption>
                                    </div>
                                    <psd-chart [index]="0" [muckpileData]="actualFragment" [type]="'muckpile'" (offSpecEmitter)="setActualOffSpec($event)"></psd-chart>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </mat-tab>
            </mat-tab-group>
        </mat-card>
    </div>
</div>
